module.exports = {
  "country": "CY",
  "artist": "Elena Tsagrinou",
  "song": "El diablo",
  "year": "2021",
  "place": "16",
  "spotify": "0DGduxy7YSuqXm272C2LM6"
};